import { useEffect, useState } from "react";

const STORAGE_KEY = "veya_country";

const SUPPORTED_COUNTRIES = ["NZ", "AU", "GB", "US"];

function normalizeCountry(value) {
  const country = String(value || "").toUpperCase();

  if (country === "UK") return "GB";

  return SUPPORTED_COUNTRIES.includes(country) ? country : "NZ";
}

function detectCountry() {
  try {
    const lang = navigator.language || "";
    const parts = lang.split("-");
    return normalizeCountry(parts[1]);
  } catch {
    return "NZ";
  }
}

export function useCountry() {
  const [country, setCountryState] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);

    if (saved) {
      setCountryState(normalizeCountry(saved));
      return;
    }

    const detected = detectCountry();
    localStorage.setItem(STORAGE_KEY, detected);
    setCountryState(detected);
  }, []);

  function setCountry(newCountry) {
    const normalized = normalizeCountry(newCountry);
localStorage.setItem(STORAGE_KEY, normalized);
setCountryState(normalized);
window.dispatchEvent(new CustomEvent("veya_country_changed", { detail: normalized }));
  }

  return {
    country,
    setCountry,
    supportedCountries: SUPPORTED_COUNTRIES,
  };
}